import { toValue, type MaybeRefOrGetter } from 'vue';

export function resolveI18n<
  TConfig extends Record<string, string | ((...params: any[]) => string)>,
  K extends keyof TConfig,
  T = TConfig[K],
>(config: MaybeRefOrGetter<TConfig>, key: K, ...args: T extends (...params: infer P) => string ? P : never[]): string {
  const resolvedConfig = toValue(config);
  const value = resolvedConfig[key];

  if (typeof value === 'function') {
    return value(...args);
  }

  return value as string;
}
